export default __webpack_public_path__ + "static/media/request2.4bcc11b0.png";